import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
import styled, { css } from 'styled-components';
import { get } from '../../styles/constant';
import { variant } from 'styled-system';
import { Box } from '..';
const Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  cursor: ", ";\n  width: ", ";\n"])), _ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 'not-allowed' : 'pointer';
}, props => props.width ? "".concat(props.width, "%") : '100%');
const FieldSet = styled.fieldset(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: 400;\n  padding: 0px;\n  margin: 0px;\n  border: 0px;\n  text-align: left;\n  width: ", " &\n    span.required {\n    &:after {\n      content: ' *';\n      color: ", ";\n    }\n  }\n"])), props => props.fit === 'small' ? get('fontSizes.14') : get('fontSizes.16'), props => props.fit === 'small' ? get('lineHeights.20') : get('lineHeights.24'), props => props.width ? "".concat(props.width, "%") : '100%', get('colors.feedback.danger.normal'));
const Input = styled.input.attrs({
  type: 'checkbox'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: 1px;\n  height: 1px;\n  opacity: ", ";\n  overflow: visible;\n  box-sizing: border-box;\n  padding: ", ";\n  white-space: nowrap;\n"])), get('space.0'), get('space.0'), get('space.0'), get('space.0'));
const styles = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  cursor: pointer;\n  &:hover {\n    border-color: ", ";\n\n    &::before {\n      box-shadow: ", ";\n    }\n  }\n  &:focus {\n    outline: 0;\n    &::before {\n      box-shadow: ", ";\n    }\n  }\n\n  &:before {\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 100px;\n    content: '';\n    position: absolute;\n    right: ", ";\n    transition: all 0.2s ease-in-out;\n  }\n  &:after {\n    background: ", ";\n    content: '';\n    position: absolute;\n    border-radius: 50%;\n    transition: all 0.2s ease-in-out;\n  }\n"])), get('colors.functional.grey.600'), get('boxShadows.type.basic.default'), get('boxShadows.type.basic.default'), get('colors.functional.grey.400'), get('colors.functional.grey.400'), get('space.0'), get('colors.functional.grey.50'));
const fit = variant({
  prop: 'fit',
  variants: {
    small: {
      '&:before': {
        top: get('space.1'),
        width: get('space.28'),
        height: get('space.16')
      },
      '&:after': {
        top: get('space.4'),
        width: get('space.12'),
        height: get('space.12'),
        right: get('space.14')
      },
      paddingRight: get('space.36')
    },
    medium: {
      '&:before': {
        top: get('space.1'),
        width: get('space.36'),
        height: get('space.20')
      },
      '&:after': {
        top: get('space.4'),
        width: get('space.16'),
        height: get('space.16'),
        right: get('space.18')
      },
      paddingRight: get('space.42')
    },
    large: {
      '&:before': {
        top: get('space.1'),
        width: get('space.44'),
        height: get('space.24')
      },
      '&:after': {
        top: get('space.4'),
        width: get('space.20'),
        height: get('space.20'),
        right: get('space.22')
      },
      paddingRight: get('space.48')
    }
  }
});
const variants = {
  fit
};
const Label = styled.label.withConfig({
  shouldForwardProp: prop => !['orientation', 'fit'].includes(prop)
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  &:after {\n    right: ", ";\n  }\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  letter-spacing: ", ";\n  font-weight: normal;\n  & span.required {\n    &:after {\n      content: ' *';\n      color: ", ";\n    }\n  }\n  &.disabled:hover::before {\n    box-shadow: none;\n  }\n"])), styles, variants.fit, props => !props.disabled && props.checked && {
  '&:before': {
    backgroundColor: '#00243d'
  },
  '&:after': {
    right: "".concat(get('space.2')(props)),
    backgroundColor: "".concat(get('colors.functional.grey.50')(props))
  }
}, props => props.disabled && {
  cursor: 'not-allowed',
  '&:before': {
    backgroundColor: "".concat(get('colors.functional.grey.200')(props)),
    borderColor: "".concat(get('colors.functional.grey.400')(props))
  },
  '&:after': {
    backgroundColor: "".concat(get('colors.functional.grey.400')(props))
  }
}, props => props.checked ? '2px' : '', props => props.fit === 'small' ? get('fontSizes.14') : get('fontSizes.16'), props => props.fit === 'small' ? get('lineHeights.20') : get('lineHeights.24'), get('colors.functional.grey.900'), get('space.0'), get('colors.feedback.danger.normal'));
const Container = styled(Box)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  ", "\n"])), _ref2 => {
  let {
    orientation
  } = _ref2;
  return orientation === 'vertical' ? 'column' : 'row';
}, _ref3 => {
  let {
    orientation,
    fit
  } = _ref3;
  return orientation === 'vertical' && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      > * {\n        &:first-child {\n          border-top: ", ";\n          margin-top: ", ";\n        }\n      }\n    "])), get('borderProperties.switch.verticalBorder'), fit === 'small' ? "".concat(get('space.8')(fit)) : fit === 'medium' ? "".concat(get('space.12')(fit)) : "".concat(get('space.16')(fit)));
});
const Group = styled(Box)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), _ref4 => {
  let {
    fit,
    orientation
  } = _ref4;
  return orientation === 'vertical' ? css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n          border-bottom: ", ";\n          padding-top: ", ";\n          padding-bottom: ", ";\n        "])), get('borderProperties.switch.verticalBorder'), fit === 'small' ? "".concat(get('space.8')(fit)) : fit === 'medium' ? "".concat(get('space.12')(fit)) : "".concat(get('space.16')(fit)), fit === 'large' ? "".concat(get('space.12')(fit)) : "".concat(get('space.8')(fit))) : css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        margin-top: ", ";\n        margin-right: ", ";};\n  "])), fit === 'small' ? "".concat(get('space.8')(fit)) : fit === 'medium' ? "".concat(get('space.12')(fit)) : "".concat(get('space.16')(fit)), fit === 'small' ? "".concat(get('space.16')(fit)) : fit === 'medium' ? "".concat(get('space.20')(fit)) : "".concat(get('space.24')(fit)));
});
const Components = {
  Wrapper,
  Input,
  Label,
  FieldSet,
  Container,
  Group
};
export { Components };